import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import IconArrowRight from "../../../icons/arrow-right.svg";
import Slider from "react-slick";
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import Parallax from "../utils/animations/parallax";
import { directions } from "../utils/animations/animationConstants";
import LazyLoad from 'react-lazyload';

export default function FourColumnLayout(props) {
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const setValues = () => {
    setIsMobile(window.innerWidth <= 767);
  };

  useEffect(() => {
    setValues();
    document.addEventListener('load', setValues);
    window.addEventListener('resize', setValues);

    return () => {
      document.removeEventListener('load', setValues);
      window.removeEventListener('resize', setValues);
    };
  }, []);

  const { header, subHeader, services, classes, technologys } = props.data;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 666,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  const triggers = [[1, 0.85], [0.9, 0.75], [0.8, 0.65], [0.7, 0.55]];

  return (
    <InView onChange={(inView) => setIsVisible(inView)} >
      <div className="section-gap " onLoad={setValues} id={props.id ? props.id : ''}>
        <div className={`section-title ${classes}`}>
          <div className="container">
            {header && <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>}
            {subHeader && <h2>{subHeader}</h2>}
          </div>
        </div>
        <div className="four-column-layout-section section-gap-small service-pages">
          <div className="container">
            <div className="row d-flex flex-wrap justify-center">

              {isMobile && <Slider {...settings}>
                {services && services.map((service, index) => {
                  return (<div className={`col four-column-item ${service.title}`} key={index}>
                    <div className="item-inner blur-on-hover">
                      <div className="grid-icon">
                        <i><LazyLoad><img src={service.image} title={service.title} alt={service.alt} /></LazyLoad></i>
                      </div>
                      <div className="item-content">
                        {/*<h3 className="h5">
                        {service.link !== "#" &&
                        <Link to={service.link}>{service.header}</Link>
                        }
                        {service.link === "#" &&
                          service.header
                        }
                       </h3>*/}
                        <h3 className="h5">
                          {service.header}
                        </h3>
                        <p>{service.content}</p>
                        <Link className="learn-more" to={service.link}>Learn More <IconArrowRight /></Link>
                      </div>
                      <ul className="list-style-icon">
                        {service.technologys && service.technologys.map((technology, index) => {
                          return (<li key={index}>
                            <i>{technology.icon}</i>
                            <h5>{technology.header}</h5>
                          </li>);
                        })}
                      </ul>
                    </div>
                    {/* <div className="hover-content">
                      <h5>{service.header}</h5>
                      <Link to={service.link}><IconArrows /></Link>
                      </div> */}
                  </div>);
                })}
              </Slider>}

              {!isMobile &&
                services && services.map((service, index) => {
                  return (<Parallax classes={`col four-column-item ${service.title}`} key={index} id={"four-column-item-" + index} direction={directions.LTR} length={50} opacity={true} triggers={triggers[index]}>
                    <div className="item-inner blur-on-hover">
                      <div className="grid-icon">
                        <i><LazyLoad><img src={service.image} title={service.title} alt={service.alt} /></LazyLoad></i>
                      </div>
                      <div className="item-content">
                        {/*<h3 className="h5">
                        {service.link !== "#" &&
                        <Link to={service.link}>{service.header}</Link>
                        }
                        {service.link === "#" &&
                          service.header
                        }
                       </h3>*/}
                        <h3 className="h5">
                          {service.header}
                        </h3>
                        <p>{service.content}</p>
                        <Link className="learn-more" to={service.link}>Learn More <IconArrowRight /></Link>
                      </div>
                      <ul className="list-style-icon">
                        {service.technologys && service.technologys.map((technology, index) => {
                          return (<li key={index}>
                            <i>{technology.icon}</i>
                            <h5>{technology.header}</h5>
                          </li>);
                        })}
                      </ul>
                    </div>
                    {/* <div className="hover-content">
                      <h5>{service.header}</h5>
                      {service.link !== "#" &&
                      <Link to={service.link}><IconArrows /></Link>
                      }
                      {service.link === "#" &&
                      <IconArrows />
                      }
                    </div> */}
                  </Parallax>);

                  //return <SlideInWithScroll clientHeight={clientHeight} elementTop={elementTop} children={jsx} triggerPoints={[triggers[index], triggers[index + 2]]} key={index} />;
                })}

            </div>
          </div>
        </div>
        <div className="bottom-action-section text-center">
          <div className="container">
            <h5>Start your new project with us!</h5>
            <Link to="/contact/" className="button button-black right-arrow">Contact Us</Link>
          </div>
        </div>
      </div>
    </InView>
  );
}

